module.exports = __webpack_public_path__ + "static/img/10.9f0dc0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/10.png
// module id = SR9L
// module chunks = 0